module.exports = __webpack_public_path__ + "static/media/about-logo.51a3b485.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-logo.svg
// module id = 451
// module chunks = 0